import { render, staticRenderFns } from "./MatchMakingTestUserFlow.vue?vue&type=template&id=10652350&scoped=true"
import script from "./MatchMakingTestUserFlow.vue?vue&type=script&lang=js"
export * from "./MatchMakingTestUserFlow.vue?vue&type=script&lang=js"
import style0 from "./MatchMakingTestUserFlow.vue?vue&type=style&index=0&id=10652350&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10652350",
  null
  
)

export default component.exports